var e={wrapper:"rl2_badge-module_wrapper_gDhLV",hasText:"rl2_badge-module_hasText_OPWtR",text:"rl2_badge-module_text_zmRqs",imageSmall:"rl2_badge-module_imageSmall_z3JZH",imageBig:"rl2_badge-module_imageBig_AAYLl"};export{e as default};
